import { Injectable, Injector, inject } from '@angular/core'
import {
  HttpResponse,
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest
} from '@angular/common/http'
import { tap, type Observable } from 'rxjs'
import { guidRegexString } from '@awork/_shared/static-data/regular-expressions'
import { UndoService } from '../undo-service/undo.service'

@Injectable()
export class UndoResponseInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector)

  /**
   * Applies the server's decision about the latest undoable change.
   * @param {HttpRequest<unknown>} req - The outgoing request.
   * @param {HttpHandler} next - The next handler.
   * @returns {Observable<HttpEvent<unknown>>} The response events.
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap(event => {
        if (!(event instanceof HttpResponse) || !event.ok) {
          return
        }

        const id = event.headers.get('aw-undo-id')

        if (id === 'none') {
          this.injector.get(UndoService).clear()
        } else if (id && new RegExp(`^${guidRegexString}$`, 'i').test(id)) {
          this.injector.get(UndoService).register({
            id,
            fields: (event.headers.get('aw-undo-fields') ?? '').split(',').filter(Boolean),
            count: Number(event.headers.get('aw-undo-count')) || 1,
            taskId: event.headers.get('aw-undo-task'),
            taskIds: (event.headers.get('aw-undo-tasks') ?? event.headers.get('aw-undo-task') ?? '')
              .split(',')
              .filter(Boolean),
            mode: event.headers.get('aw-undo-mode') === 'redo' ? 'redo' : 'undo'
          })
        }
      })
    )
  }
}
